import type { RecommendationCategory } from '@lizrd/contracts';
import { RECO_CATEGORY_META } from '../lib/reco-categories';
import { cn } from '../lib/utils';

/**
 * The lucide icon for a recommendation category (Bedrock icon system — replaces the
 * old per-category emoji). `tint` paints it in the category's data-viz colour; left
 * off, it inherits the surrounding text colour for a restrained, neutral look.
 */
export function CategoryIcon({
  category,
  className,
  tint = false,
}: {
  category: RecommendationCategory;
  className?: string;
  tint?: boolean;
}) {
  const meta = RECO_CATEGORY_META[category];
  const Icon = meta.icon;
  return (
    <Icon
      aria-hidden
      className={cn('h-4 w-4 shrink-0', className)}
      style={tint ? { color: meta.color } : undefined}
    />
  );
}
